import { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import config from "../config";
import { OnlineUserEntry, useOnlineUsersStore } from "store/onlineUsers";

const HUB_URL = `${config.apiUrl.replace(/\/$/, "")}/hubs/online-users`;

const sendPage = (hub: HubConnection, path: string) => {
    if (hub.state === "Connected") {
        hub.invoke("UpdatePage", path).catch(() => {});
    }
};

export const useOnlineUsersConnection = () => {
    const { setOnlineUsers, setIncomingMessage } = useOnlineUsersStore();
    const connectionRef = useRef<HubConnection | null>(null);
    const location = useLocation();
    const pathnameRef = useRef(location.pathname);

    useEffect(() => {
        pathnameRef.current = location.pathname;
        if (connectionRef.current) {
            sendPage(connectionRef.current, location.pathname);
        }
    }, [location.pathname]);

    //useEffect(() => {
    //    let isCancelled = false;

    //    const hub = new HubConnectionBuilder()
    //        .withUrl(HUB_URL, { withCredentials: true })
    //        .withAutomaticReconnect()
    //        .configureLogging(LogLevel.None)
    //        .build();

    //    hub.on("OnlineUsersUpdated", (users: OnlineUserEntry[]) => {
    //        if (!isCancelled) setOnlineUsers(users);
    //    });

    //    hub.on("ReceiveMessage", (payload: { from: string; message: string; sentAt: string }) => {
    //        if (!isCancelled) setIncomingMessage(payload);
    //    });

    //    hub.onreconnected(() => sendPage(hub, pathnameRef.current));

    //    hub.start()
    //        .then(() => {
    //            if (isCancelled) {
    //                hub.stop();
    //            } else {
    //                connectionRef.current = hub;
    //                sendPage(hub, pathnameRef.current);
    //            }
    //        })
    //        .catch((err: Error) => {
    //            if (!isCancelled && !err?.message?.includes("stopped during negotiation")) {
    //                console.error("SignalR connection error:", err);
    //            }
    //        });

    //    return () => {
    //        isCancelled = true;
    //        connectionRef.current = null;
    //        hub.stop();
    //    };
    //}, []);

    const sendMessage = (message: string, targetUsernames: string[]) => {
        //connectionRef.current?.invoke("SendMessage", message, targetUsernames).catch(() => {});
    };

    return { sendMessage };
};

// Lightweight read-only hook for the OnlineUsers display page
export const useOnlineUsers = () => {
    const { onlineUsers } = useOnlineUsersStore();
    return { onlineUsers, count: onlineUsers.length };
};